import { Centered } from '@studio/design-system/overlay';
import { Spinner } from '@studio/design-system/spinner';
import { vendorName } from '@studio/design-system/themes/vendor.js';
import { useLayoutEffect, type ReactElement } from 'react';

/** `<Shutdown>` component. */
export const Shutdown = (): ReactElement => {
  // Per rule timeouts-are-band-aids (ai.knowledge/global): main's
  // lifecycle._runCleanup awaits this ack instead of a fixed 250ms paint-window
  // timer, so teardown does not close the BrowserWindow before the user has
  // actually seen the shutdown UI. useLayoutEffect runs after React commits the
  // DOM; the double-requestAnimationFrame ensures the ack fires AFTER the
  // browser paints the committed tree (the first rAF callback fires before the
  // next paint, the inner rAF fires after that paint commits).
  useLayoutEffect(() => {
    let raf2 = 0;
    const raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(() => {
        window.electron?.ipcRenderer?.send('window:shutting-down-ack');
      });
    });
    return () => {
      cancelAnimationFrame(raf1);
      if (raf2) cancelAnimationFrame(raf2);
    };
  }, []);

  return (
    <Centered>
      {/* `data-testid="loading-screen"` + `loading-screen-text` + `boot-spinner`
       * mirror the boot loading surface's testids so the boot-overlay
       * shutdown-after-confirm e2e probe (readOverlayProbe) sees a loading
       * screen + spinner and reads "Shutting down" from the same testids it
       * reads the boot copy from. The text-testid's textContent is exactly
       * "Shutting down" (trailing vendor name + ellipsis live in a sibling
       * span) so the equality check in boot-overlay.spec.ts holds. */}
      <div data-testid='loading-screen' className='flex items-center gap-8 text-xl'>
        <span data-testid='boot-spinner'>
          <Spinner />
        </span>{' '}
        <span data-testid='loading-screen-text'>Shutting down</span> {vendorName()}...
      </div>
    </Centered>
  );
};
